import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-12 h-12 rounded-full bg-slate-200 animate-pulse border-2 border-white shadow-sm z-[1]"
}
const _hoisted_2 = {
  key: 1,
  class: "flex items-center gap-2 z-[1]"
}
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-6 h-6 transition-colors",
  viewBox: "0 0 24 24"
}
const _hoisted_4 = ["d", "fill"]

import { ref, computed } from 'vue'
import { mdiLock, mdiLockOpenVariant } from '@mdi/js'
import { ExceptionSummaryStatus } from '@/Network/Types/Responses/StationResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    status: {},
    isActive: { type: Boolean },
    loading: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;





const hover = ref(false)

const labelMap: Record<string, string> = {
  APPROVED: 'Aprovado',
  IN_PROGRESS: 'Em Andamento',
  IN_REVIEW: 'Em revisão'
}

const statusLabel = computed(() => {
  return props.status ? labelMap[props.status] : null
})

const iconPath = computed(() =>
  [null, ExceptionSummaryStatus.IN_PROGRESS].includes(props.status) ? mdiLock : mdiLockOpenVariant
)

const iconFillColor = computed(() => {
  if (props.status === null) {
    return hover.value ? '#235E6C' : '#3CA2B9'
  }

  switch (props.status) {
    case ExceptionSummaryStatus.APPROVED:
      return hover.value ? '#DA1E28' : '#DA1E28A3'
    case ExceptionSummaryStatus.IN_PROGRESS:
      return hover.value ? '#F18F1B' : '#F18F1BA3'
    case ExceptionSummaryStatus.IN_REVIEW:
      return hover.value ? '#F1C21B' : '#F1C21BA3'
    default:
      return '#FFFFFF' // Cor de fallback
  }
})

return (_ctx: any,_cache: any) => {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (statusLabel.value && !_ctx.isActive)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["px-2 py-1 rounded-md border text-sm font-medium text-textPrimary", {
        'bg-[#FCE9EA] border-negative': _ctx.status === _unref(ExceptionSummaryStatus).APPROVED,
        'bg-[#FEF3E7] border-alert': _ctx.status === _unref(ExceptionSummaryStatus).IN_PROGRESS,
        'bg-[#FEF9E7] border-warning': _ctx.status === _unref(ExceptionSummaryStatus).IN_REVIEW
      }])
            }, _toDisplayString(statusLabel.value), 3))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
          class: _normalizeClass(["w-12 h-12 flex items-center justify-center rounded-full border-2 transition-all cursor-pointer bg-white", {
        'border-negative bg-[#FCE9EA]': _ctx.status === _unref(ExceptionSummaryStatus).APPROVED,
        'border-alert bg-[#FEF3E7]': _ctx.status === _unref(ExceptionSummaryStatus).IN_PROGRESS,
        'border-warning bg-[#FEF9E7]': _ctx.status === _unref(ExceptionSummaryStatus).IN_REVIEW,
        'border-primary30': !_ctx.status
      }]),
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (hover.value = true)),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (hover.value = false))
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, [
            _createElementVNode("path", {
              d: hover.value && _ctx.status === null ? _unref(mdiLockOpenVariant) : iconPath.value,
              fill: iconFillColor.value
            }, null, 8, _hoisted_4)
          ]))
        ], 34)
      ]))
}
}

})